export default __webpack_public_path__ + "static/Edith-021f12d01734ef47d04fd8fed3531154.png";